
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Baby } from "lucide-react";

interface BabyDevelopmentProps {
  currentWeek: number;
}

const getFetalIcon = () => {
  return Baby;
};

const monthDescriptions: { [key: number]: string } = {
  1: "Formation initiale des organes vitaux",
  2: "Développement du système nerveux",
  3: "Formation des membres et des doigts",
  4: "Premiers mouvements détectables",
  5: "Développement des sens et réflexes",
  6: "Maturation des organes principaux",
  7: "Ouverture des yeux et développement cérébral",
  8: "Prise de poids et maturation pulmonaire",
  9: "Position finale pour la naissance",
};

export const BabyDevelopment = ({ currentWeek }: BabyDevelopmentProps) => {
  const currentMonth = Math.ceil(currentWeek / 4);
  const currentTrimester = Math.ceil(currentMonth / 3);

  const getMonthsForTrimester = (trimester: number) => {
    const start = (trimester - 1) * 3 + 1;
    return [start, start + 1, start + 2];
  };

  return (
    <Card className="w-full shadow-sm border">
      <CardHeader className="bg-muted/50">
        <CardTitle className="text-2xl text-center text-primary">Développement du bébé</CardTitle>
      </CardHeader>
      <CardContent className="space-y-8 p-6">
        <div className="text-center mb-8 bg-card p-6 rounded-lg shadow-sm border">
          <p className="text-2xl font-semibold text-primary mb-2">
            Mois {currentMonth} (Semaine {currentWeek})
          </p>
          <p className="text-muted-foreground">
            {monthDescriptions[currentMonth] || "Développement en cours"}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((trimester) => (
            <div
              key={trimester}
              className={`p-6 rounded-xl transition-all duration-300 ${
                currentTrimester === trimester
                  ? "bg-muted/50 shadow-sm border" 
                  : "bg-background"
              }`}
            >
              <h3 className="text-xl font-semibold text-primary mb-4 text-center">
                {trimester}er Trimestre
              </h3>
              <div className="space-y-4">
                {getMonthsForTrimester(trimester).map((month) => (
                  <div
                    key={month}
                    className={`bg-card p-4 rounded-lg transition-all duration-300 ${
                      currentMonth === month 
                        ? "ring-2 ring-primary shadow-sm border transform hover:scale-105" 
                        : "shadow-sm border hover:shadow-md"
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
                        currentMonth === month ? "bg-primary/10" : "bg-muted"
                      }`}>
                        {React.createElement(getFetalIcon(), {
                          className: `w-8 h-8 ${
                            currentMonth === month 
                              ? "text-primary animate-pulse" 
                              : "text-muted-foreground"
                          }`,
                          size: 32,
                        })}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-medium text-foreground">Mois {month}</h4>
                        <p className="text-sm text-muted-foreground line-clamp-2">
                          {monthDescriptions[month]}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
